import styled from 'styled-components';

export const CreateButton = styled.button`
  background-color: ${props => props.variant ? props.variant : '#007bff'};
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 20px;
  ${props => props.pullright && props.pullright === "true" && `margin-left: auto; margin-right: 0px;`}
`;

export const AddUserButton = styled.button`
  background-color: ${props => props.variant ? props.variant : '#007bff'};
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  margin-left: auto;
  margin-bottom: 20px;
`;